import { v4 } from 'uuid';
import * as cookie from './cookie';

const UNDEFINED = -1;

export const initialize = () => {
  cookie.setCookie('books.watermark', v4());
  cookie.setCookie('books.seq', new Date().getTime());
  cookie.setCookie('books.finishedStep', UNDEFINED);
};

export const watermark = (): string => cookie.getCookie('books.watermark')!;

export const finalize = (step: number) => {
  cookie.setCookie('books.watermark', '');
  cookie.setCookie('books.finishedStep', step);
};

export const setSeq = (sequential: number) => {
  cookie.setCookie('books.seq', sequential);
};

export const seq = (): number =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  parseInt(cookie.getCookie('books.seq', seq)!, 10);

export const finishedStep = (): number | undefined => {
  const step = parseInt(cookie.getCookie('books.finishedStep')!, 10);
  return step === UNDEFINED ? undefined : step;
};
